module.exports = __webpack_public_path__ + "img/ae21096.jpg";